/* istanbul ignore file */
export enum AuthActionTypesEnum {
    LOG_IN = 'auth/log-in',
    LOG_OUT = 'auth/log-out'
}
